
import { Base } from "@/models";

export class QuestionOption extends Base {
    value: string;
    slug: string;
}